import { ClearFormatting } from 'almanac-ui/icons/16'
import { useClearFormattingButton } from 'common/Prose/Toolbar/hooks/useClearFormattingButton'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const ClearFormattingFormatButton = observer(function ClearFormattingFormatButton({
  view,
  callback,
}: {
  view: EditorView
  callback?: () => void
}) {
  const clearFormatting = useClearFormattingButton(view)

  return (
    <InlineFormatDropdownMenuItem
      data-testid="Clear formatting"
      label="Clear formatting"
      onPress={() => {
        clearFormatting()
        callback?.()
      }}
      icon={<ClearFormatting />}
    />
  )
})
